import {
  DrawerContent,
  DrawerOverlay,
  DrawerCloseButton,
  DrawerHeader,
  DrawerBody,
  Box,
  Drawer,
  useBreakpointValue,
} from '@chakra-ui/react';

import { useSidebarDrawer } from '../../../contexts/SidebarDrawerContext';
import { SidebarNav } from './SideBarNav/nav_miles';
import { SidebarNavBi } from './SideBarNav/Nav_bi/nav_bi';
import { SidebarNavProfile } from './SideBarNav/nav_profile';
import { SidebarNavAdm } from './SideBarNav/nav_adm';
import { SidebarNavOS } from './SideBarNav/nav_order_services';
import { SidebarNavExpenses } from './SideBarNav/nav_expenses';
import { SidebarNavQuality } from './SideBarNav/nav_quality';
import { SidebarNavFeedAnalysis } from './SideBarNav/nav_feed_analysis';

interface Props {
  path:
    | 'miles'
    | 'bi'
    | 'profile'
    | 'adm'
    | 'os'
    | 'expenses'
    | 'quality'
    | 'feed-analysis';
}

export function Sidebar({ path }: Props) {
  const { isOpen, onClose } = useSidebarDrawer();
  const isDrawerSidebar = useBreakpointValue({
    base: true,
    lg: false,
  });

  if (isDrawerSidebar || path === 'bi' || path === 'profile') {
    return (
      <Drawer isOpen={isOpen} placement="left" onClose={onClose}>
        <DrawerOverlay>
          <DrawerContent bg="gray.800" p="4">
            <DrawerCloseButton mt="6" />
            <DrawerHeader>Navegação</DrawerHeader>

            <DrawerBody overflow="auto">
              {path === 'miles' && <SidebarNav />}
              {path === 'bi' && <SidebarNavBi />}
              {path === 'profile' && <SidebarNavProfile />}
              {path === 'os' && <SidebarNavOS />}
              {path === 'expenses' && <SidebarNavExpenses />}
              {path === 'quality' && <SidebarNavQuality />}
              {path === 'feed-analysis' && <SidebarNavFeedAnalysis />}
            </DrawerBody>
          </DrawerContent>
        </DrawerOverlay>
      </Drawer>
    );
  }

  return (
    <Box as="aside" w="64" mr="8">
      {path === 'miles' && <SidebarNav />}
      {path === 'os' && <SidebarNavOS />}
      {path === 'adm' && <SidebarNavAdm />}
      {path === 'expenses' && <SidebarNavExpenses />}
      {path === 'quality' && <SidebarNavQuality />}
      {path === 'feed-analysis' && <SidebarNavFeedAnalysis />}
    </Box>
  );
}
